export default {
  translation: {
    common: {
      accept: '同意する',
      alreadyUser: 'すでにアカウントをお持ちですか？',
      and: 'および',
      backToLogin: 'ログインページに戻る',
      continueWith: '{{provider}}で続行',
      coreNotFound: 'コア設定の取得に失敗しました',
      createAccount: 'アカウントを作成',
      createYourAccount: 'アカウントを作成する',
      emailOrUsername: 'メールアドレスまたはユーザー名',
      invalidUsernameOrPassword: 'ユーザー名またはパスワードが正しくありません',
      localRegistrationDisabled: 'ローカルユーザー登録は管理者によって無効化されています',
      login: 'ログイン',
      logInToBoards: 'ログイン',
      newToBoards: '4ga Boardsは初めてですか?',
      noInternetConnection: 'インターネット接続がありません',
      pageNotFound_title: 'ページが見つかりません',
      password: 'パスワード',
      policyNotAccepted: '利用規約とプライバシーポリシーに同意してください',
      privacyPolicy: 'プライバシーポリシー',
      register: '登録',
      registerWithGoogle: 'Googleで登録',
      registrationDisabled: 'ユーザー登録は管理者によって無効化されています',
      serverConnectionFailed: 'サーバーへの接続に失敗しました',
      ssoRegistrationDisabled: 'SSO登録は管理者によって無効化されています',
      termsOfService: '利用規約',
      togglePasswordVisibility: 'パスワードの表示/非表示',
      unknownError: '不明なエラー、後でもう一度お試しください',
    },

    action: {
      logIn: 'ログイン',
    },
  },
};
